import JsBarcode from "jsbarcode";
import QRCode from "qrcode";

const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

export const barkodSvg = (deger) => {
  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  JsBarcode(svg, deger, { format: "CODE128", height: 48, width: 2, fontSize: 14, margin: 0 });
  return svg.outerHTML;
};

export const yazdir = (baslik, govde, css = "") => {
  const w = window.open("", "_blank");
  if (!w) return false;
  w.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>${esc(baslik)}</title><style>
    body{font-family:Arial,sans-serif;margin:12px;color:#111} h1{font-size:18px;margin:0 0 8px} table{border-collapse:collapse;width:100%;font-size:12px}
    th,td{border:1px solid #999;padding:5px;text-align:left} th{background:#eee} .r{text-align:right} ${css}
    @media print{.np{display:none}}</style></head><body>${govde}<script>setTimeout(()=>window.print(),400)</script></body></html>`);
  w.document.close();
  return true;
};

export const rafEtiketYazdir = async (depoAd, gozler) => {
  const kartlar = await Promise.all(gozler.map(async (g) => `<div class="et"><div class="k">${esc(g.konum)}</div>
    <div class="row">${barkodSvg(g.konum)}<img src="${await QRCode.toDataURL(g.konum, { margin: 0, width: 90 })}" /></div>
    <div class="s">${esc(depoAd)} · Koridor ${esc(g.koridor || "-")} · Raf ${esc(g.raf)} · Sütun ${g.sutun} · Göz ${g.kat}</div><div class="s">RFID ${esc(g.epc)}</div></div>`));
  return yazdir(`Raf etiketleri ${depoAd}`, `<div class="grid">${kartlar.join("")}</div>`,
    `.grid{display:grid;grid-template-columns:repeat(2,1fr);gap:8px}.et{border:1px dashed #555;padding:8px;break-inside:avoid}.k{font-size:26px;font-weight:700}
     .row{display:flex;align-items:center;justify-content:space-between;gap:8px;margin:4px 0}.row svg{max-width:68%}.s{font-size:10px;color:#333}`);
};

export const toplamaListesiYazdir = ({ siparis_no, cari }, depolar) => {
  const parcalar = depolar.map((d) => `<h1>${esc(d.depo_ad)} · ${d.rota ? `${d.rota.mesafe} m` : "rota yok"}</h1><table><thead><tr><th>#</th><th>Göz</th><th>Ürün</th><th>Ad</th><th>Lot</th><th class="r">Miktar</th><th>✓</th></tr></thead><tbody>
    ${d.sirali.map((x, i) => `<tr><td>${i + 1}</td><td><b>${esc(x.konum || "Yerleşmemiş")}</b></td><td>${esc(x.kod)}</td><td>${esc(x.ad)}</td><td>${esc(x.lot)}</td><td class="r">${x.miktar} ${esc(x.birim)}</td><td style="width:30px"></td></tr>`).join("")}
    </tbody></table><p style="font-size:11px">Başlangıç: GİRİŞ → sırayla gözler → SEVKİYAT çıkışı</p>`).join("");
  return yazdir(`Toplama listesi ${siparis_no}`, `<h1>Toplama Listesi · ${esc(siparis_no)} · ${esc(cari)}</h1><p style="font-size:11px">${new Date().toLocaleString("tr-TR")}</p>${parcalar}`);
};
